import React from 'react';
// nodejs library to set properties for components
import Grid, { type GridProps } from '@mui/material/Grid';

type LegacyGridSize = number | 'auto' | 'grow' | boolean;

interface GridItemProps extends GridProps {
  className?: string;
  children?: React.ReactNode;
  xs?: LegacyGridSize;
  sm?: LegacyGridSize;
  md?: LegacyGridSize;
  lg?: LegacyGridSize;
  xl?: LegacyGridSize;
}

export default function GridItem(props: GridItemProps) {
  const { children, className = '', sx, xs, sm, md, lg, xl, size, ...rest } =
    props;
  const hasLegacySizeProps =
    xs !== undefined ||
    sm !== undefined ||
    md !== undefined ||
    lg !== undefined ||
    xl !== undefined;
  const responsiveSize =
    size ??
    (hasLegacySizeProps
      ? {
          xs: xs === true ? 'grow' : xs,
          sm: sm === true ? 'grow' : sm,
          md: md === true ? 'grow' : md,
          lg: lg === true ? 'grow' : lg,
          xl: xl === true ? 'grow' : xl,
        }
      : undefined);
  return (
    <Grid
      {...rest}
      size={responsiveSize as GridProps['size']}
      className={className}
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: '1px',
        paddingRight: '15px',
        paddingLeft: '15px',
        /* flexBasis: "auto" */
        ...(sx as object),
      }}
    >
      {children}
    </Grid>
  );
}
